import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

const CashIcon: React.FC<IconProps> = ({ color = "#09090B", size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99992 10C7.77325 10 7.66659 9.42667 7.66659 9.33333H6.33325C6.33325 9.94667 6.77325 11.0333 8.33325 11.28V12H9.66659V11.28C10.9999 11.0533 11.6666 10.1933 11.6666 9.33333C11.6666 8.58667 11.3199 7.33333 8.99992 7.33333C7.66659 7.33333 7.66659 6.91333 7.66659 6.66667C7.66659 6.42 8.13325 6 8.99992 6C9.86659 6 9.92659 6.42667 9.93325 6.66667H11.2666C11.2576 6.2125 11.0942 5.77494 10.8034 5.42597C10.5126 5.077 10.1117 4.83743 9.66659 4.74667V4H8.33325V4.72667C6.99992 4.94667 6.33325 5.80667 6.33325 6.66667C6.33325 7.41333 6.67992 8.66667 8.99992 8.66667C10.3333 8.66667 10.3333 9.12 10.3333 9.33333C10.3333 9.54667 9.91992 10 8.99992 10Z"
      fill={color}
    />
    <path
      d="M4.33325 1.33331H2.33325V2.66665H3.66659V14C3.66659 14.1768 3.73682 14.3464 3.86185 14.4714C3.98687 14.5964 4.15644 14.6666 4.33325 14.6666H13.6666C13.8434 14.6666 14.013 14.5964 14.138 14.4714C14.263 14.3464 14.3333 14.1768 14.3333 14V2.66665H15.6666V1.33331H4.33325ZM12.9999 13.3333H4.99992V2.66665H12.9999V13.3333Z"
      fill={color}
    />
  </svg>
);

export default CashIcon;
